import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import classes from './SideBarItem.css';
import Arrow from '../../../Arrow/Arrow';

const sideBarItem = props => {
  const { closeSideBar, title, page, selectedItem } = props;
  return (
    <Link to={page} style={{ textDecoration: 'none' }}>
      <li
        className={classes.SideBarItem}
        onClick={closeSideBar}
        onKeyDown={closeSideBar}
      >
        <h2
          className={
            selectedItem
              ? classes.SideBarItemActive
              : classes.SideBarItemInactive
          }
        >
          {title}
        </h2>
        <Arrow
          direction={selectedItem ? 'nextSideBarActive' : 'nextSideBarInactive'}
        />
      </li>
    </Link>
  );
};

sideBarItem.propTypes = {
  title: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  selectedItem: PropTypes.bool,
  closeSideBar: PropTypes.func
};

export default withRouter(sideBarItem);
